module.exports = __webpack_public_path__ + "static/media/Banner.997d31b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/ThreeHundred/Banner.png
// module id = 442
// module chunks = 5